import SectionBanner from "components/cards/SectionBanner";
import CampaignIMG from 'assets/images/megaphone.svg';
import NotificationList from "./NotificationList_";
import { useTranslation } from "react-i18next";
import { getI18nValue } from 'utils/Utils';
import { FaFacebookMessenger, FaWhatsapp } from 'react-icons/fa'
import DashboardWrapper from "components/wrappers/DashboardWrapper"

const Campaigns = () => {

  const { t } = useTranslation();

  return (
    <DashboardWrapper >
      <SectionBanner
        title={t(getI18nValue('campaigns', "title"))}
        desc={
          <div>
            {t(getI18nValue('campaigns', "description"))}
          </div>
        }
      >
        <img src={CampaignIMG} alt='' height='150px' width='150px' />
      </SectionBanner>

      <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 rounded" role="alert">
        <p className="font-bold">{t('form.notification_target')}</p>
        <p className="text-sm font-medium">{t('warning.notification_target')}</p>
      </div>

      <div className="mt-8">
        <NotificationList />
      </div>

    </DashboardWrapper >
  );
}

export default Campaigns;


export const pickChannel = (id, enabled) => {
  switch (id) {
    case "1":
      return <FaWhatsapp
        className={`mx-2 ${enabled ? "text-green-600" : "text-gray-300"}`}
        title={enabled ? "WhatsApp (enabled)" : "WhatsApp (disabled)"}
        aria-label={enabled ? "WhatsApp enabled" : "WhatsApp disabled"}
      />
    case "2":
      return <FaFacebookMessenger
        className={`mx-2 ${enabled ? "text-sky-500" : "text-gray-300"}`}
        title={enabled ? "Messenger (enabled)" : "Messenger (disabled)"}
        aria-label={enabled ? "Messenger enabled" : "Messenger disabled"}
      />
    default:
      return null
  }
}


export const pickStatus = (id, value) => {
  switch (id) {
    case "1":
      return <span className="rounded px-2 py-1 text-yellow-600 border border-yellow-500 bg-yellow-100">
        {value}
      </span>
    case "2":
      return <span className="rounded px-2 py-1 text-green-600 border border-green-500 bg-green-100">
        {value}
      </span>
    case "3":
      return <span className="rounded px-2 py-1 text-gray-600 border border-gray-500 bg-gray-100">
        {value}
      </span>
    default:
      return null
  }
}